import React = require('react')
import { List } from 'immutable'
import { fromJSX, Option, Updater, Widget } from 'widgets-for-react'
import { MainLayout } from '../../../../../main/main.layout'
import { PublicSiteState } from '../../../../../root/state'
import { TemplateState } from '../../cms/page/types.gen'
import { Breadcrumb } from '../../drupal/types_and_parser/extra_types.mod'
import { inert } from '../application.mod'
import { pageheaderWidget } from './drupal_page_header.mod'

export const page =
  (
    extra_info: Option<JSX.Element>,
    pageContentRef?: React.RefObject<HTMLDivElement>
  ): ((placeholder: Widget<Updater<TemplateState>>) => (_: PublicSiteState) => Widget<Updater<TemplateState>>) =>
  (blocks) =>
  ({ page, viewportWidth, siteheader, breakpoint }) => {
    const node = page.page.kind === 'loaded' ? page.page.value.extra_data.node : undefined
    const breadcrumbs =
      page.page.kind === 'loaded' && page.page.value.extra_data.breadcrumb.kind == 'loaded'
        ? page.page.value.extra_data.breadcrumb.value
        : List<Breadcrumb>()
    const pageLanguage = document.querySelector('html').getAttribute('lang')
    const parsedNodeLanguage = node ? node.language : null
    return fromJSX((setState) => (
      <MainLayout className={`main main--${node ? node.bundle : 'default'}`} inert={inert({ siteheader, breakpoint })}>
        <article className="page" lang={pageLanguage !== parsedNodeLanguage ? parsedNodeLanguage : null}>
          {node && pageheaderWidget({ breadcrumbs, node, viewportWidth }).run(() => null)}
          <div className="page__content" ref={pageContentRef}>
            {extra_info.kind == 'r' ? extra_info.v : null}
            {blocks.run(setState)}
          </div>
        </article>
      </MainLayout>
    ))
  }
